import Flickity from 'flickity';

import HeroComponent from '../components/hero';
import YouTubeEmbedAPI from '../modules/YouTubeEmbedAPI';

export default class GradingController {

  constructor(options) {
    this.options = options;
    console.log('GRADING CONTROLLER');

    this.ourfarms_hero = new HeroComponent({
      elem      :'section.pro_hero',
      parallaxCopy : true,
    });

    this.YTE = new YouTubeEmbedAPI();

    $('.is-video').click( (e) => {
      e.preventDefault();

      $('div.site__overlay').addClass('is-active');
      $('div.modal--video').addClass('is-active');

      const videoID = $(e.currentTarget).data('videoid');
      console.log(videoID, $(e.currentTarget));
      this.YTE.createPlayer(videoID);
    });

    $('a.is-gallery').click( (e) => {
      e.preventDefault();
      const newElements = [];
      $.each(this.elements, (ind, element) => {
        if (element.className.indexOf(`${this.options.gallery_prefix}_step${e.target.attributes.value.value}_gallery`) !== -1) {
          const newElement = $(element);
          console.log(newElement);
          console.log(newElement.data('image'));
          const img = newElement.data('image');
          newElement.css('background-image', `url("${img}")`);
          console.log(newElement);
          newElements.push(element);
        }
      });

      $('div.site__overlay').addClass('is-active');
      $('div.modal--gallery').addClass('is-active');

      this.flkty.remove(this.elements);
      this.flkty.append(newElements);
    });

    $('div.modal').click( (e) => {
      if ( $(e.target).hasClass('modal') ||
        $(e.target).hasClass('modal__close') ) {

        $('div.site__overlay').removeClass('is-active');
        $('div.modal').removeClass('is-active');

        if (this.YTE.enabled) {
          this.YTE.destroyPlayer();
        }
      }
    });

    this.elements = $('.modal__gallery__cntr').children();
    console.log(this.elements);
    // init flickity
    this.flkty = new Flickity( 'div.modal__gallery__cntr', {
      arrowShape: { x0: 0, x1: 40, y1: 50, x2: 50, y2: 50, x3: 10 },
      cellAlign: 'center',
      wrapAround: true,
      pageDots: true,
      setGallerySize: false,
    });
    this.transitionIn();

    // track the scroll position
    $(window).scroll( e => this.handleScroll(e) );

  }


  transitionIn() {
    // reveal the home hero text
    $('.pro_hero .cmpnt__hero__copy__cntr').addClass('do-intro');

    setTimeout( () => {
      $('.pro_hero .cmpnt__hero__copy__cntr').removeClass('do-intro start-intro');
    }, 2300);

    // animate what's on screen
    this.handleScroll();


  }

  handleScroll() {
    const st = $(window).scrollTop();
    const trig = $(window).height() * 0.75;

    $('.pro__box').each( (i, v) => {
      if ( $(v).offset().top - st < trig && !$(v).hasClass('has-animated') ) {
        $(v).addClass('has-animated');
      }
    });

  }

}



// WEBPACK FOOTER //
// ./js/controllers/pages/GradingController.js